$(document).on('click', '.tabbed-payment-ui nav li', function() {

  var $this = $(this),
      tabToShow = $this.data('tab');

  if ($this.hasClass('active')) {
    return;
  }

  // Disable all other links & tabs
  $('.tabbed-payment-ui nav li').removeClass('active');
  $('.tabbed-payment-ui .content-wrapper .active').fadeOut(150).removeClass('active');

  // Enable current link & show tab
  $this.addClass('active');
  setTimeout(function() {
    $(tabToShow).fadeIn().addClass('active');
  }, 200)
});
